import Vue from "vue";
import store from "../store";
import JwtDecode from "jwt-decode";
import axios from "axios";

const colorMap = {
    'Pendiente': "background: #f0f1f3; color: #637381",
    'Borrador': "background: #f0f1f3; color: #637381",
    'Aprobado': "background: #e8f9f5; color: #13c296",
    'Denegado': "background: #feebeb ; color: #e10e0e",
    'Rechazado': "background: #feebeb ; color: #e10e0e",
    'Autorizado': "background: #edf0ff; color: #3758f9",
    'Enviado': "background: #e8f9f5; color: #13c296",
    'En proceso': "background: #d0f0fd; color: #0b76b7",
    'Observado': "background: #fffbeb; color: #d97706",
    'Modificado': "background: #d0f0fd; color: #0b76b7",
    'Finalizada': "background: #edf0ff; color: #3758f9",
    'Finalizado': "background: #acf2c9; color: #37a661",
    'En ejecución': "background: #d0f0fd; color: #0b76b7",
    'Activo': "background: #e8f9f5; color: #13c296",
    'Programado': "background: #fffbeb; color: #d97706",
    'Verificado': "background: #d0f0fd; color: #0b76b7",
    'Enviado a revisión': "background: #F5F3FF; color: #6D28D9",
    'En configuración': "background: #feebeb ; color: #e10e0e",
    'Aprobado SAFI': "background: #edf0ff; color: #3758f9",
    'Cerrado': "background: #f0f1f3; color: #637381",
    'Revisión finalizada': "background: #e8f9f5; color: #13c296",
    'Enviado a SAFI': "background: #edf0ff; color: #3758f9",
    'Cerrada': "background: #f0f1f3; color: #637381",
    'Vigente': "background: #e8f9f5; color: #13c296",
    'Inactivo': "background: #f0f1f3; color: #637381",
    'configurado': "background: #e8f9f5; color: #13c296",
    'pendiente': "background: #f0f1f3; color: #637381",

  1: "background: #f0f1f3; color: #637381", // Borrador
  4: "background: #f0f1f3; color: #637381", // Pendiente
  6: "background: #fffbeb; color: #d97706", // Observado
  7: "background: #e8f9f5; color: #13c296", // Aprobado
  9: "background: #edf0ff; color: #3758f9", // Autorizado
  10: "background: #d0f0fd; color: #0b76b7", // En proceso
  12: "background: #d0f0fd; color: #0b76b7", // Modificado
  13: "background: #feebeb ; color: #e10e0e", // Denegado
  8: "background: #e8f9f5; color: #13c296", // Enviado
  // 
    false: "background: #e8f9f5; color: #13c296",
    true: "background: #f0f1f3; color: #637381",
};

Vue.prototype.$colorStatus = (status) => {
    return colorMap[status] || "background: #e9eaeb; color:#111928";
};

Vue.prototype.showLoader = async () => {
    await store.commit("utils/setLoader", true);
};

Vue.prototype.hideLoader = async () => {
    await store.commit("utils/setLoader", false);
}

Vue.prototype.temporalAlert = async (alert) => {
    await store.commit("utils/setAlert", alert);
};

Vue.prototype.validateNotEmojis = (value) => {
    if (value === null) return true;
    return value.match(/(\p{Emoji_Presentation}|\p{Extended_Pictographic})/gu) !== null ? false : true;
}

Vue.prototype.isDui = (dui) => {
    if (dui === null) return false;
    let valido = false;

    // Validando la longitud del numero de DUI
    if (dui.length === 10) {
        // Validando que no sea ceros todos los dígitos
        if (dui !== "00000000-0") {
            // Obteniendo los dígitos y el verificador
            let [digitos, validador] = dui.split("-");

            // Verficiando que la cadena
            if (typeof digitos !== "undefined" && typeof validador !== "undefined") {
                // Verificando que el validador sea de un solo caracter
                if (validador.length === 1) {
                    // Convirtiendo los digitos a array
                    digitos = digitos.split("");

                    // Convirtiendo los datos a tipo integer
                    validador = parseInt(validador, 10);
                    digitos = digitos.map((digito) => parseInt(digito, 10));

                    // Obteniendo la suma corresponiente
                    let suma = digitos.reduce(
                        (total, digito, index) => (total += digito * (9 - index)),
                        0
                    );

                    // Obteniendo el Modulo base 10
                    let mod = suma % 10;
                    mod = validador === 0 && mod === 0 ? 10 : mod;

                    let resta = 10 - mod;

                    if (resta === validador) {
                        valido = true;
                    }
                }
            }
        }
    }
    return valido;
};

Vue.prototype.isNit = (nit) => {
    if (nit === null) return false;

    let valido = false;

    // Validando la longitud del numero de DUI
    if (nit.length === 17) {
        // Validando que no sea ceros todos los dígitos
        if (
            nit !== "0000-000000-000-0" &&
            nit.match(/^[0-9]{4}-[0-9]{6}-[0-9]{3}-[0-9]$/)
        ) {
            // Obteniendo los dígitos y el verificador por separado
            let [ubicacion, fecha, correlativo, validador] = nit.split("-");
            let digitos = (ubicacion + fecha + correlativo).split("");

            // Convirtiendo los datos a tipo integer
            validador = parseInt(validador, 10);
            correlativo = parseInt(correlativo, 10);
            let suma = 0;
            let mod = 0;
            if (correlativo <= 100) {
                // Obteniendo la suma corresponiente
                suma = digitos.reduce(
                    (total, digito, index) =>
                        (total += parseInt(digito, 10) * (14 - index)),
                    0
                );
                // Obteniendo el Modulo base 11
                mod = suma % 11;
                mod = mod === 10 ? 0 : mod;
            } else {
                // Obteniendo la suma corresponiente
                suma = digitos.reduce(
                    (total, digito, index) =>
                    (total +=
                        parseInt(digito, 10) *
                        parseInt(3 + 6 * Math.floor((index + 5) / 6) - (index + 1), 10)),
                    0
                );
                // Obteniendo el Modulo base 11
                mod = suma % 11;
                mod = mod > 1 ? 11 - mod : 0;
            }
            if (mod === validador) {
                valido = true;
            }
        }
    }
    return valido;
};

Vue.prototype.getPaginationProperties = (response) => {
    return {
        page: Number(response?.headers.page),
        per_page: Number(response?.headers.per_page),
        total_rows: Number(response?.headers.total_rows)
    }
}
//Funcion auxiliar para verificar paths accesibles
const buscarRuta = (rutas, ruta) => {
    return true
    return rutas.some((item) => {
        if (item?.childrens?.length > 0)
            if (buscarRuta(item?.childrens, ruta)) return true

        return item.nombre_uri.toLowerCase() === ruta.name.toLowerCase();
    });
};
//Funcion para verificar las paths accesibles
Vue.prototype.canNext = async (ruta, token) => {
    //Rutas a las que el usuario siempre va a poder acceder
    const permit = [
        "Forbidden",
        "security",
        "login",
        "forgot-password",
        "reset-password",
        "2fa",
        "verifyMail",
        "inicio",
        "menu"
    ];

    if (permit.includes(ruta.name)) return true;

    if (!token) {
        return false;
    }

    try {
        let decoded = JwtDecode(token);
        const now = Date.now() / 1000;
        
        // Verificar si el token ha expirado
        if (decoded.exp < now) {

            const token = localStorage.getItem('token');
            const tokenID = localStorage.getItem('tokenID');
            const session_uuid = localStorage.getItem('session_uuid');
            axios.post(process.env.VUE_APP_API_URL + '/api/v1/logout-identidad', { tokenID: tokenID, session_uuid }, 'post', { Authorization: `Bearer ${token}` }).then(res=> (res)).catch(error=>(error))

            // Limpiar token expirado
            localStorage.removeItem("token");
            localStorage.removeItem("refresh_token");
            localStorage.removeItem("session_uuid");
            localStorage.removeItem("tokenID");

            store.commit("utils/setAlert", {
                show: true,
                message: "Sesión expirada, por favor inicie sesión nuevamente.",
                type: "error",
            });
            
            return false;
        }

        return true;
    } catch (error) {
        // Token inválido, limpiar localStorage
        localStorage.removeItem("token");
        localStorage.removeItem("session_uuid");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("tokenID");
        
        store.commit("utils/setAlert", {
            show: true,
            message: "Sesión expirada, por favor inicie sesión nuevamente.",
            type: "error",
        });

        return false;
    }
};
